// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Jw-z","tooltipWrapper":"Kw-z","icon":"Lw-z","tooltip":"Mw-z","content":"Nw-z"};